// AccessiBe Widget (Deferred)
(function() {
  'use strict';
  
  function loadAccessiBe() {
    (function(){ 
      var s = document.createElement('script'); 
      var h = document.querySelector('head') || document.body; 
      s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; 
      s.async = true; 
      s.onload = function(){ 
        acsbJS.init({ 
          statementLink : '', 
          footerHtml : '', 
          hideMobile : false, 
          hideTrigger : false, 
          disableBgProcess : false, 
          language : 'en', 
          position : 'left', 
          leadColor : '#222A3E', 
          triggerColor : '#146ff8', 
          triggerRadius : '10px', 
          triggerPositionX : 'right', 
          triggerPositionY : 'bottom', 
          triggerIcon : 'people', 
          triggerSize : 'big', 
          triggerOffsetX : 20, 
          triggerOffsetY : 80, 
          mobile : { 
            triggerSize : 'small', 
            triggerPositionX : 'right', 
            triggerPositionY : 'bottom', 
            triggerOffsetX : 10, 
            triggerOffsetY : 80, 
            triggerRadius : '10px' 
          } 
        }); 
      }; 
      h.appendChild(s); 
    })();
  }

  // Load only after user interaction or 5 seconds (whichever comes first)
  var accessibeLoaded = false;
  
  function initAccessiBe() {
    if (!accessibeLoaded) {
      accessibeLoaded = true;
      loadAccessiBe();
    }
  }

  // Fallback: Load after 5 seconds if no interaction
  window.addEventListener('load', function() {
    setTimeout(initAccessiBe, 5000);
  });
  
  // Load immediately on first user interaction
  ['click', 'scroll', 'touchstart', 'keydown', 'mousemove'].forEach(function(event) {
    document.addEventListener(event, initAccessiBe, { once: true, passive: true });
  });
})();